import { toCamel } from "./toCamel"

export const transformKeys = (object: any, options: any) => {
  if (options.transformKeys === "camelCase") {
    return toCamel(object)
  }

  return object
}
